import { render, staticRenderFns } from "./ad-search-word.vue?vue&type=template&id=3bf2415b&scoped=true&"
import script from "./ad-search-word.vue?vue&type=script&lang=js&"
export * from "./ad-search-word.vue?vue&type=script&lang=js&"
import style0 from "./ad-search-word.vue?vue&type=style&index=0&id=3bf2415b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2415b",
  null
  
)

export default component.exports